import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { AdressverwaltungModule } from '@schir-int-client/adressverwaltung';
import { ApiRootModule } from '@schir-int-client/api-root';
import { BinarySharedModule } from '@schir-int-client/binary-shared';
import { DashboardModule, DashboardPageComponent } from '@schir-int-client/dashboard';
import { EipSharedModule } from '@schir-int-client/eip-shared';
import { EnvironmentModule } from '@schir-int-client/environment';
import { KorrespondenzSharedModule } from '@schir-int-client/korrespondenz-shared';
import { NavbarModule } from '@schir-int-client/navbar';
import { SignaturSharedModule } from '@schir-int-client/signatur-shared';
import { UserSharedModule } from '@schir-int-client/user-shared';
import { UsignalModule } from '@schir-int-client/usignal-shared';
import { VerfahrenModule } from '@schir-int-client/verfahren';
import { VerfuegungModule } from '@schir-int-client/verfuegung';
import { VorgangModule } from '@schir-int-client/vorgang';
import { VorlageModule } from '@schir-int-client/vorlage';
import { EnumToLabelPipe, FormatDatePipe } from '@schir-int-client/tech';
import { AppComponent } from './app.component';
import { SchirStoreModule } from './shared/store/store.module';
import { ErrorModule, WhitelabelErrorPageComponent } from '@schir-int-client/error';
import { StatistikModule } from '@schir-int-client/statistik';
import { TextbausteinModule } from '@schir-int-client/textbaustein';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

registerLocaleData(localeDe, 'de', localeDeExtra);

const routes: Routes = [
	{
		path: '',
		component: DashboardPageComponent,
	},
	{
		path: 'error',
		component: WhitelabelErrorPageComponent,
	},
	{
		path: '**', // wildcard route to catch all undefined routes
		redirectTo: '/error',
	},
];

@NgModule({
	declarations: [AppComponent],
	exports: [RouterModule],
	bootstrap: [AppComponent],
	imports: [
		EnvironmentModule,
		SchirStoreModule,
		BrowserModule,
		BrowserAnimationsModule,
		RouterModule.forRoot(routes, {}),
		StoreRouterConnectingModule.forRoot(),
		MatMomentDateModule,
		MatIconModule,
		ApiRootModule,
		NavbarModule,
		VorgangModule,
		DashboardModule,
		VerfahrenModule,
		VorlageModule,
		VerfuegungModule,
		AdressverwaltungModule,
		EipSharedModule,
		KorrespondenzSharedModule,
		UserSharedModule,
		BinarySharedModule,
		UsignalModule,
		SignaturSharedModule,
		ErrorModule,
		StatistikModule,
		MatFormFieldModule,
		MatInputModule,
		TextbausteinModule,
	],
	providers: [
		{
			provide: 'Window',
			useValue: window,
		},
		EnumToLabelPipe,
		FormatDatePipe,
		{
			provide: LOCALE_ID,
			useValue: 'de',
		},
		{
			provide: MAT_DATE_LOCALE,
			useValue: 'de-DE',
		},
		{
			provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
			useValue: {
				useUtc: true,
				strict: false,
			},
		},
		provideHttpClient(withInterceptorsFromDi()),
	],
})
export class AppModule {}
